// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1__dX","cls2":"ReferenceEvaluationPage-cls2_qRJ ReferenceEvaluationPage-cls1__dX"};